<template>
  <div>{{ msg }}</div>
</template>
<script>
import requestHTAPI from '@/axios/HantangTax'
import { getUrlParam } from '@/libs/utils'
export default {
  name: 'checkRoot',
  data () {
    return {
      code: '',
      url: '',
      msg: '请求中...'
    }
  },
  mounted () {
    this.code = getUrlParam('code')
    this.url = decodeURIComponent(getUrlParam('url'))
    console.log('获取到的完整URL:', this.url)
    this.sendCode(this.url)
  },
  methods: {
    sendCode (url) {
      // 发请求拿openid
      const formData = new FormData()
      formData.append('code', this.code)
      requestHTAPI.sendCode(formData).then(res => {
        if (res.data.code === '0000') {
          // code 给后台并存上token
          const data = res.data.data
          sessionStorage.setItem('TOKEN', data.token)
          // 保留完整的URL包括查询参数
          if (url.includes('?')) {
            // 如果URL包含查询参数，直接使用完整路径
            this.$router.replace(url)
          } else {
            // 如果没有查询参数，使用原来的方式
            this.$router.replace({
              path: url
            })
          }
        } else {
          // this.sendCode(url)
          this.msg = '请重新授权'
          this.$toast.fail('请重新授权')
        }
      }).catch(error => {
        console.log(error)
        // this.sendCode(url)
        this.msg = '服务异常，请重新授权'
        this.$toast.fail('服务异常，请重新授权')
      })
    }
  }
}
</script>
<style scoped>
</style>
